// @flow
import React from "react"
import classnames from "classnames"
import type { Node, Element } from "react"

import Translate from "../../../../app/scripts/components/Translate"
import Loader from "../IconLoader/IconLoader"
import ButtonWrapper from "../ButtonWrapper/ButtonWrapper"
import type { ButtonSize, ButtonKind } from "../ButtonWrapper/ButtonWrapper"

type Props = {
  size: ButtonSize,
  kind: ButtonKind,
  children: Node,
  iconLeft?: Element<any>,
  iconRight?: Element<any>,
  className?: string,
  onClick?: (ev: SyntheticEvent<>) => void,
  loading?: boolean,
  loadingText?: boolean,
  disabled?: boolean,
  type?: string,
  id?: string,
  fullwidth?: boolean,
  dataTest?: string,
}

const Button = ({
  size,
  kind,
  fullwidth,
  disabled,
  loading,
  loadingText,
  iconLeft,
  iconRight,
  className,
  onClick,
  type,
  dataTest,
  id,
  children,
}: Props) => (
  <ButtonWrapper
    size={size}
    kind={kind}
    fullwidth={fullwidth}
    disabled={disabled}
    loading={loading}
    className={classnames("Button", className, {
      _loading: loading,
    })}
  >
    <button onClick={onClick} type={type} disabled={disabled} data-test={dataTest} id={id}>
      <span className="ButtonWrapper-content">
        {loading && (
          <span className="Button-icon _left">
            <Loader />
          </span>
        )}

        {loadingText && loading && <Translate tKey="common.loading" />}
        {!loading && iconLeft && <span className="Button-icon _left">{iconLeft}</span>}
        {!loadingText && children}
        {!loading && iconRight && <span className="Button-icon _right">{iconRight}</span>}
      </span>
    </button>
  </ButtonWrapper>
)

Button.defaultProps = {
  size: "medium",
  kind: "primary",
}

export default Button
